/**
 * List.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import ListItem from './ListItem';
/**
 * Renders a list of items.
 *
 * @param {{items: Array<*>, onItemClick: (item: any) => void}} param0
 */

function List(_ref) {
  var items = _ref.items,
      onItemClick = _ref.onItemClick;
  return React.createElement('ul', {
    className: 'itemList'
  }, items.map(function (item, key) {
    return React.createElement('li', {
      key: key
    }, ListItem({
      item: item,
      onClick: function onClick() {
        onItemClick(item);
      }
    }));
  }));
}

export default List;